import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEumin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.006 17.993a8.994 8.994 0 1 0 0-17.988 8.994 8.994 0 0 0 0 17.988Z",
		fill: "#039"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m9.007 2.005-.225.69h-.725l.585.424-.22.694.585-.424.583.424-.219-.694.585-.425H9.23l-.224-.69Zm.224 12.68-.224-.689-.225.69h-.725l.585.424-.22.695.585-.425.583.425-.22-.695.585-.425h-.724Zm-6.22-5.299.585.421-.22-.694.584-.425h-.724L3.01 8l-.225.69h-.724l.584.424-.22.694.585-.421Zm2.996-6.577-.225.69H5.06l.584.429-.22.69.584-.432.585.43-.22-.69.585-.429h-.723l-.227-.688ZM3.815 5.003l-.224.69h-.725l.585.424-.225.694.59-.424.584.424-.225-.694.59-.425H4.04l-.225-.69Zm.225 6.684-.225-.689-.225.69h-.724l.585.424-.225.694.59-.424.584.425-.225-.695.59-.425H4.04Zm2.193 2.195-.226-.69-.223.69h-.725l.584.43-.219.688.583-.43.585.43-.22-.69.586-.428h-.725Zm9.718-5.192h-.724L15.002 8l-.225.69h-.725l.584.424-.218.693.584-.421.585.421-.22-.694.584-.424Zm-3.947-5.881-.225.69h-.724l.585.429-.22.69.584-.432.585.43-.22-.69.584-.429h-.724l-.225-.688Zm1.834 3.308-.225.694.585-.424.59.424-.226-.694.585-.425h-.725l-.224-.69-.225.69h-.725l.59.425Zm.584 5.57-.225-.689-.225.69h-.724l.59.424-.225.694.584-.424.59.425-.225-.695.585-.425h-.725Zm-2.193 2.196-.225-.69-.225.69h-.724l.585.43-.22.688.584-.43.585.43-.22-.689.584-.43h-.724Z",
		fill: "#FC0"
	})]
});
const ForwardRef = forwardRef(SvgIconEumin);
export { ForwardRef as ReactComponent };
